<div class="container">

  <p class="title">
    Environmental Performance Module
    <mat-icon class="titleIcon">chevron_right</mat-icon> CII

  </p>


  <!-- <button class="refresh-btn"
          matTooltip="Refresh"
          matTooltipPosition="below"
          (click)="refreshPageData()">
    <mat-icon class="refresh-icon">refresh</mat-icon>
  </button> -->




  <app-expansion-panel style="margin-top: 25px;" [titleText]="'Table Filter'" class="panel">
    <div class="filter" [ngClass]="{ 'dark-filter': isDarkMode() }">
      <form [formGroup]="myreportForm">
        <div class="filterRow">

          <div class="col">
            <app-custom-date-picker [label]="'From Date:'" [controlname]="this.myreportForm.controls['from_date']">
            </app-custom-date-picker>
          </div>

          <div class="col">
            <app-custom-date-picker [label]="'To Date:'" [controlname]="this.myreportForm.controls['to_date']">
            </app-custom-date-picker>
          </div>

          <div class="col">
            <app-custom-input [label]="'Vessel I.M.O'" [controlname]="this.myreportForm.controls['vesselIMO']">
            </app-custom-input>
          </div>

          <div class="col">
            <label class="vesselNameLabel" [ngClass]="{ 'dark-label': isDarkMode() }">
              Vessel Name
            </label>
            <input type="text" class="form-control" formControlName="vesselname" (input)="filterShipNames($event)"
              [matAutocomplete]="autoShip" />
            <mat-autocomplete #autoShip="matAutocomplete">
              <mat-option *ngFor="let ship of vesselNameSuggestions" [value]="ship.ship_name">
                {{ ship.ship_name }}
              </mat-option>
            </mat-autocomplete>
          </div>

          <div class="col">
            <app-custom-dropdown [label]="'Month'" [items]="monthOptions"
              [controlname]="this.myreportForm.controls['month']">
            </app-custom-dropdown>
          </div>

          <div class="filterBtn">
            <button class="btn btn-light hover-button apply" (click)="clearClick()">
              <mat-icon>clear_all</mat-icon>
              <span class="name">Clear Filter</span>
            </button>
          </div>

          <div class="filterBtn">
            <button class="btn btn-light hover-button apply" (click)="filterClick()">
              <mat-icon>filter_list</mat-icon>
              <span class="name">Apply Filter</span>
            </button>
          </div>

        </div>
      </form>
    </div>
  </app-expansion-panel>


  <!-- TABLE -->
  <div class="table-container scroll-bar" [ngClass]="{ 'dark-table': isDarkMode() }">
    <table class="mat-elevation-z8 printable-table" id="style-4">


      <thead class="sticky-header">


        <tr>
          <th rowspan="2">Sr No</th>
          <th rowspan="2"  *ngIf="subusername !== 'demo'">Vessel No</th>
          <th rowspan="2"  *ngIf="subusername !== 'demo'">IMO No</th>

          <th rowspan="2">BDN No</th>
          <th rowspan="2">Date of Bunkering</th>
          <th rowspan="2">Grade</th>

          <th colspan="2" class="text-center">Fuel Properties</th>

          <th rowspan="2">Sulphur Content<br>(% m/m)</th>
          <th rowspan="2">Qty Received<br>(MT)</th>
          <th rowspan="2">Discrepancy<br>(MT)</th>
        </tr>


        <tr>
          <th>Density @15°C<br>(kg/m³)</th>
          <th>Kinematic Viscosity<br>@50°C (mm²/s)</th>
        </tr>

      </thead>


      <tbody>
        <ng-container *ngFor="let row of paginatedData; let i = index">
          <tr>
            <!-- Sr No -->
            <td>{{ i + 1 }}</td>

            <!-- Vessel Name -->
            <td  *ngIf="subusername !== 'demo'">{{ row.vessel_name || '-' }}</td>

            <!-- IMO No -->
            <td  *ngIf="subusername !== 'demo'">{{ row.imo || '-' }}</td>

            <!-- BDN No (NOT AVAILABLE) -->
            <td>{{ row.document_number || '-' }}</td>

            <!-- Date of Bunkering -->
            <td>{{ row.document_date | date:'dd-MMM-yyyy' }}</td>

            <!-- Grade -->
            <td>{{ row.products?.[0]?.product || '-' }}</td>

            <!-- Density @15°C -->
            <td>{{ +row.products?.[0]?.density_15c ? row.products?.[0]?.density_15c : '-' }}</td>

            <!-- Viscosity @50°C -->
            <td>{{ +row.products?.[0]?.viscosity_50c_cst ? row.products?.[0]?.viscosity_50c_cst : '-' }}</td>

            <!-- Sulphur Content -->
            <td>{{ +row.products?.[0]?.sulphur_percent ? row.products?.[0]?.sulphur_percent : '-' }}</td>

            <!-- Qty Received (MT) -->
            <td>{{ +row.products?.[0]?.qty_mt ? row.products?.[0]?.qty_mt : '-' }}</td>

            <!-- Discrepancy -->
            <td>-</td>
          </tr>
        </ng-container>
      </tbody>


    </table>
  </div>






  <mat-paginator [length]="elements.length" [pageSize]="itemsPerPage" [pageSizeOptions]="[100]"
    (page)="onPageChange($event)" [ngClass]="{ 'dark-paginator': isDarkMode() }" showFirstLastButtons>
  </mat-paginator>

  <div class="text-right">
    <button class="btn btn-light hover-button mail" (click)="downloadClick()">
      <mat-icon>download</mat-icon>&nbsp; Export
    </button>
  </div>

</div>

<br />